import React from 'react';
import Modal from 'components/Modal';
import { StyledLongBody } from 'components/ChangePassewordModal/styles';
import { get } from 'lodash';
import { translate } from 'helpers/intl';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/MyAccountPage/messages';
import Content from 'components/ConfirmPasswordModal/Content';

const ConfirmPasswordModal = (props: ConfirmPasswordModalType) => {
  const {
    isOpen,
    handleClose,
    error,
    helperText,
    handleChange,
    handleBlur,
    value,
    handleSubmit,
    isLoading,
  } = props;
  return (
    <Modal
      open={isOpen}
      handleClose={handleClose}
      header={
        <StyledLongBody weight="500" color="#04336B">
          {translate(get(messages, 'title'), props)}
        </StyledLongBody>
      }
      content={
        <Content
          error={error}
          helperText={helperText}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={value}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          handleClose={handleClose}
        />
      }
    />
  );
};

export interface ConfirmPasswordModalType {
  intl: IntlShape;
  isOpen: boolean;
  handleClose: Function;
  error: string | false | undefined;
  helperText: string | false | undefined;
  handleChange: Function;
  handleBlur: Function;
  value: string;
  handleSubmit: Function;
  isLoading: boolean;
}

export default injectIntl(ConfirmPasswordModal);
